import { Object3D, Property } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';

import { Cursor } from '@wonderlandengine/components';
import { InteractableBase } from './interactable-base.js';
import { TriggerTarget } from './triggerTarget.js';
import { wlUtils } from '@sorskoot/wonderland-components';

export class InteractableTrigger extends InteractableBase {
    static TypeName = 'interactable-trigger';
    static InheritProperties = true;

    @property.array(Property.object())
    targets: Object3D[] = [];

    @property.bool(false)
    once = false;

    private _triggered: boolean = false;
    private _triggerTargets: TriggerTarget[] = [];

    start(): void {
        super.start();

        for (const target of this.targets) {
            const triggerTarget = target.getComponent(TriggerTarget);
            if (!triggerTarget) {
                console.warn(
                    `TriggerTarget component not found on target: ${target.name}`
                );
                continue; // Skip if TriggerTarget is not found
            }
            this._triggerTargets.push(triggerTarget);
        }
    }
    /**
     * Handles interaction with the object. Shows description text if available
     * and starts inspection/carry behavior based on itemType.
     * @param cursor - The cursor that triggered the interaction
     * @override
     */
    override interact(cursor: Cursor) {
        if (this.once && this._triggered) {
            return; // Ignore further collisions if 'once' is true and already triggered
        }
        this._triggerTargets.forEach((target: TriggerTarget) => {
            target?.execute(); // Execute the trigger target action
        });
        this._triggered = true; // Set triggered to true if it is a one-time trigger

        if (this.once) {
            wlUtils.setActive(this.object, false); // Deactivate the object if it is a one-time trigger
            //this.object.destroy(); // Destroy the object if it is a one-time trigger
        }
    }
}
